module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0145.jpg?v=167bd091";